import React, { useMemo, useState } from "react";
import { useTemplatesGallery } from "../../../hooks/useTemplatesGallery";
import { Switch } from "@material-ui/core";
import { Spinner } from "reactstrap";
import TemplateCard from "./TemplateCard";

const TemplateGallery = ({ name }) => {
  const { templates, loading } = useTemplatesGallery();
  const [watermark, setWatermark] = useState(false);

  const filteredTemplates = useMemo(() => {
    if (templates?.length === 0) return [];

    return templates.filter((template) => template.hasWatermark === watermark);
  }, [watermark, templates]);

  return (
    <div className="arr-content">
      <div className="arr-heading">
        <h1>Template Gallery</h1>

        <div className="watermark-input">
          <label htmlFor="watermark">Watermark</label>
          <Switch
            className="arr-switch"
            name="watermark"
            checked={watermark}
            onClick={(e) => setWatermark((prev) => !prev)}
            inputProps={{ "aria-label": "controlled" }}
          />
        </div>
      </div>

      {loading ? (
        <div className="new-spinner-container">
          <div className="new-spinner">
            <div className="loader">
              <Spinner color="primary" />
            </div>
            <div style={{ fontSize: "16px", marginTop: "15px" }}>
              Please wait !! Processing.....
            </div>
          </div>
        </div>
      ) : filteredTemplates?.length > 0 ? (
        <div data-testid="templatesContainer" className={"a4-grid"}>
          {filteredTemplates?.map((t) => (
            <TemplateCard key={t.id} url={t.url} name={t.name} />
          ))}
        </div>
      ) : (
        <div className="empty-data">No Data found</div>
      )}
    </div>
  );
};

export default TemplateGallery;
